import * as CONST from "./actionTypes";

export const getAgencies = (payload, params, callBack) => {
  return {
    type: CONST.GET_AGENCIES,
    payload,
    params,
    callBack,
  };
};
  
export const getAgenciesSuccess = (payload, callBack) => {
  return {
    type: CONST.GET_AGENCIES_SUCCESS,
    payload,
    callBack,
  };
};

export const getAgenciesFail = (payload, callBack) => {
  return {
    type: CONST.GET_AGENCIES_FAIL,
    payload,
    callBack,
  };
};

export const updateAgenciesData = (payload, callBack) => {
  return {
    type: CONST.UPDATE_AGENCIES_DATA,
    payload,
    callBack,
  };
};



// by id

export const getAgencyView = (payload, callBack) => {
  return {
    type: CONST.GET_AGENCY_VIEW,
    payload,
    callBack,
  };
};

export const getAgencyViewSuccess = (payload, callBack) => {
  return {
    type: CONST.GET_AGENCY_VIEW_SUCCESS,
    payload,
    callBack,
  };
};

export const getAgencyViewFail = (payload, callBack) => {
  return {
    type: CONST.GET_AGENCY_VIEW_FAIL,
    payload,
    callBack,
  };
};
